export default {
  name: "local",
  api: {
    baseUrl: "http://localhost:5000",
  },
};
